//user types*************************************************************************************************
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const GET_ACTIVE_SERVICES_START = "GET_ACTIVE_SERVICES_START";
export const GET_ACTIVE_SERVICES_SUCCESS = "GET_ACTIVE_SERVICES_SUCCESS";
export const GET_ACTIVE_SERVICES_FAIL = "GET_ACTIVE_SERVICES_FAIL";

export const GET_CHECK_BALANCE_START = "GET_CHECK_BALANCE_START";
export const GET_CHECK_BALANCE_SUCCESS = "GET_CHECK_BALANCE_SUCCESS";
export const GET_CHECK_BALANCE_FAIL = "GET_CHECK_BALANCE_FAIL";

export const WALLET_FUND_REQ_START = "WALLET_FUND_REQ_START";
export const WALLET_FUND_REQ_SUCCESS = "WALLET_FUND_REQ_SUCCESS";
export const WALLET_FUND_REQ_FAIL = "WALLET_FUND_REQ_FAIL";

export const SESSION_TYPE_START = "SESSION_TYPE_START";

export const USER_DATA_START = "USER_DATA_START";

export const REFUND_WALLET_CASHOUT_DATA = "REFUND_WALLET_CASHOUT_DATA";

export const LOGIN_RESETTER = "LOGIN_RESETTER";

//dashboard types*************************************************************************************************
export const GET_DASHBOARD_START = "GET_DASHBOARD_START";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAIL = "GET_DASHBOARD_FAIL";

export const GET_SUPER_DASHBOARD_START = "GET_DASHBOARD_START";
export const GET_SUPER_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_SUPER_DASHBOARD_FAIL = "GET_DASHBOARD_FAIL";

// reports types*************************************************************************************************
export const GET_LEDGER_REPORTS_START = "GET_LEDGER_REPORTS_START";
export const GET_LEDGER_REPORTS_SUCCESS = "GET_LEDGER_REPORTS_SUCCESS";
export const GET_LEDGER_REPORTS_FAIL = "GET_LEDGER_REPORTS_FAIL";

export const GET_DMT_REPORTS_START = "GET_DMT_REPORTS_START";
export const GET_DMT_REPORTS_SUCCESS = "GET_DMT_REPORTS_SUCCESS";
export const GET_DMT_REPORTS_FAIL = "GET_DMT_REPORTS_FAIL";

export const GET_RECEIVE_TOP_UP_REPORTS_START =
  "GET_RECEIVE_TOP_UP_REPORTS_START";
export const GET_RECEIVE_TOP_UP_REPORTS_SUCCESS =
  "GET_RECEIVE_TOP_UP_REPORTS_SUCCESS";
export const GET_RECEIVE_TOP_UP_REPORTS_FAIL =
  "GET_RECEIVE_TOP_UP_REPORTS_FAIL";

export const GET_WALLET_LOAD_REPORTS_START = "GET_WALLET_LOAD_REPORTS_START";
export const GET_WALLET_LOAD_REPORTS_SUCCESS =
  "GET_WALLET_LOAD_REPORTS_SUCCESS";
export const GET_WALLET_LOAD_REPORTS_FAIL = "GET_WALLET_LOAD_REPORTS_FAIL";

export const GET_AEPS_TRANSACT_REPORTS_START =
  "GET_AEPS_TRANSACT_REPORTS_START";
export const GET_AEPS_TRANSACT_REPORTS_SUCCESS =
  "GET_AEPS_TRANSACT_REPORTS_SUCCESS";
export const GET_AEPS_TRANSACT_REPORTS_FAIL = "GET_AEPS_TRANSACT_REPORTS_FAIL";

export const GET_AEPS_PAYOUT_REPORTS_START = "GET_AEPS_PAYOUT_REPORTS_START";
export const GET_AEPS_PAYOUT_REPORTS_SUCCESS =
  "GET_AEPS_PAYOUT_REPORTS_SUCCESS";
export const GET_AEPS_PAYOUT_REPORTS_FAIL = "GET_AEPS_PAYOUT_REPORTS_FAIL";

export const GET_AEPS_LEDGER_REPORTS_START = "GET_AEPS_LEDGER_REPORTS_START";
export const GET_AEPS_LEDGER_REPORTS_SUCCESS =
  "GET_AEPS_LEDGER_REPORTS_SUCCESS";
export const GET_AEPS_LEDGER_REPORTS_FAIL = "GET_AEPS_LEDGER_REPORTS_FAIL";

export const SCAN_AND_PAY_REPORTS_START = "SCAN_AND_PAY_REPORTS_START";
export const SCAN_AND_PAY_REPORTS_SUCCESS = "SCAN_AND_PAY_REPORTS_SUCCESS";
export const SCAN_AND_PAY_REPORTS_FAIL = "SCAN_AND_PAY_REPORTS_FAIL";

export const PAY_RENT_REPORTS_START = "PAY_RENT_REPORTS_START";
export const PAY_RENT_REPORTS_SUCCESS = "PAY_RENT_REPORTS_SUCCESS";
export const PAY_RENT_REPORTS_FAIL = "PAY_RENT_REPORTS_FAIL";

export const RECHARGE_REPORTS_START = "RECHARGE_REPORTS_START";
export const RECHARGE_REPORTS_SUCCESS = "RECHARGE_REPORTS_SUCCESS";
export const RECHARGE_REPORTS_FAIL = "RECHARGE_REPORTS_FAIL";

export const ACCOUNT_OPENING_TRANSACTION_REPORTS_START =
  "ACCOUNT_OPENING_TRANSACTION_REPORTS_START";
export const ACCOUNT_OPENING_TRANSACTION_REPORTS_SUCCESS =
  "ACCOUNT_OPENING_TRANSACTION_REPORTS_SUCCESS";
export const ACCOUNT_OPENING_TRANSACTION_REPORTS_FAIL =
  "ACCOUNT_OPENING_TRANSACTION_REPORTS_FAIL";

//dmt types*************************************************************************************************
export const GET_REMITTER_DETAILS_FOR_DMT_START =
  "GET_REMITTER_DETAILS_FOR_DMT_START";
export const GET_REMITTER_DETAILS_FOR_DMT_SUCCESS =
  "GET_REMITTER_DETAILS_FOR_DMT_SUCCESS";
export const GET_REMITTER_DETAILS_FOR_DMT_FAIL =
  "GET_REMITTER_DETAILS_FOR_DMT_FAIL";

export const GET_BENI_BY_REMITTER_START = "GET_BENI_BY_REMITTER_START";
export const GET_BENI_BY_REMITTER_SUCCESS = "GET_BENI_BY_REMITTER_SUCCESS";
export const GET_BENI_BY_REMITTER_FAIL = "GET_BENI_BY_REMITTER_FAIL";

export const ADD_REMITTER_FOR_DMT_START = "ADD_REMITTER_FOR_DMT_START";
export const ADD_REMITTER_FOR_DMT_SUCCESS = "ADD_REMITTER_FOR_DMT_SUCCESS";
export const ADD_REMITTER_FOR_DMT_FAIL = "ADD_REMITTER_FOR_DMT_FAIL";

export const ADD_BENE_FOR_DMT_START = "ADD_BENE_FOR_DMT_START";
export const ADD_BENE_FOR_DMT_SUCCESS = "ADD_BENE_FOR_DMT_SUCCESS";
export const ADD_BENE_FOR_DMT_FAIL = "ADD_BENE_FOR_DMT_FAIL";

export const DELETE_BENE_FOR_DMT_START = "DELETE_BENE_FOR_DMT_START";
export const DELETE_BENE_FOR_DMT_SUCCESS = "DELETE_BENE_FOR_DMT_SUCCESS";
export const DELETE_BENE_FOR_DMT_FAIL = "DELETE_BENE_FOR_DMT_FAIL";

export const PENNY_DROP_START = "PENNY_DROP_START";
export const PENNY_DROP_SUCCESS = "PENNY_DROP_SUCCESS";
export const PENNY_DROP_FAIL = "PENNY_DROP_FAIL";

export const DMT_CHARGE_CALC_START = "DMT_CHARGE_CALC_START";
export const DMT_CHARGE_CALC_SUCCESS = "DMT_CHARGE_CALC_SUCCESS";
export const DMT_CHARGE_CALC_FAIL = "DMT_CHARGE_CALC_FAIL";

export const DMT_TRANSCT_START = "DMT_TRANSCT_START";
export const DMT_TRANSCT_SUCCESS = "DMT_TRANSCT_SUCCESS";
export const DMT_TRANSCT_FAIL = "DMT_TRANSCT_FAIL";

export const REFUNDED_LIST_START = "REFUNDED_LIST_START";
export const REFUNDED_LIST_SUCCESS = "REFUNDED_LIST_SUCCESS";
export const REFUNDED_LIST_FAIL = "REFUNDED_LIST_FAIL";

//Aeps types*************************************************************************************************

export const CHECK_MERCHANT_KYC_START = "CHECK_MERCHANT_KYC_START";
export const CHECK_MERCHANT_KYC_SUCCESS = "CHECK_MERCHANT_KYC_SUCCESS";
export const CHECK_MERCHANT_KYC_FAIL = "CHECK_MERCHANT_KYC_FAIL";

export const AEPS_MERCHANT_KYC_START = "AEPS_MERCHANT_KYC_START";
export const AEPS_MERCHANT_KYC_SUCCESS = "AEPS_MERCHANT_KYC_SUCCESS";
export const AEPS_MERCHANT_KYC_FAIL = "AEPS_MERCHANT_KYC_FAIL";

export const AEPS_TRANSACT_START = "AEPS_TRANSACT_START";
export const AEPS_TRANSACT_SUCCESS = "AEPS_TRANSACT_SUCCESS";
export const AEPS_TRANSACT_FAIL = "AEPS_TRANSACT_FAIL";

export const AEPS_TO_DMT_START = "AEPS_TO_DMT_START";
export const AEPS_TO_DMT_SUCCESS = "AEPS_TO_DMT_SUCCESS";
export const AEPS_TO_DMT_FAIL = "AEPS_TO_DMT_FAIL";

export const GET_AEPS_BANK_LIST_START = "GET_AEPS_BANK_LIST_START";
export const GET_AEPS_BANK_LIST_SUCCESS = "GET_AEPS_BANK_LIST_SUCCESS";
export const GET_AEPS_BANK_LIST_FAIL = "GET_AEPS_BANK_LIST_FAIL";

export const AEPS_PENNY_DROP_START = "AEPS_PENNY_DROP_START";
export const AEPS_PENNY_DROP_SUCCESS = "AEPS_PENNY_DROP_SUCCESS";
export const AEPS_PENNY_DROP_FAIL = "AEPS_PENNY_DROP_FAIL";

export const ADD_BANK_START = "ADD_BANK_START";
export const ADD_BANK_SUCCESS = "ADD_BANK_SUCCESS";
export const ADD_BANK_FAIL = "ADD_BANK_FAIL";

export const AEPS_PAYOUT_TO_BANK_START = "AEPS_PAYOUT_TO_BANK_START";
export const AEPS_PAYOUT_TO_BANK_SUCCESS = "AEPS_PAYOUT_TO_BANK_SUCCESS";
export const AEPS_PAYOUT_TO_BANK_FAIL = "AEPS_PAYOUT_TO_BANK_FAIL";

//Recharge types
export const RECHARGE_MOBILE_START = "RECHARGE_MOBILE_START";
export const RECHARGE_MOBILE_SUCCESS = "RECHARGE_MOBILE_SUCCESS";
export const RECHARGE_MOBILE_FAIL = "RECHARGE_MOBILE_FAIL";

export const RECHARGE_DTH_START = "RECHARGE_DTH_START";
export const RECHARGE_DTH_SUCCESS = "RECHARGE_DTH_SUCCESS";
export const RECHARGE_DTH_FAIL = "RECHARGE_DTH_FAIL";

//payrent Types
export const GET_BENI_LIST_BY_REMITTER_MOBILE_START =
  "GET_BENI_LIST_BY_REMITTER_MOBILE_START";
export const GET_BENI_LIST_BY_REMITTER_MOBILE_SUCCESS =
  "GET_BENI_LIST_BY_REMITTER_MOBILE_SUCCESS";
export const GET_BENI_LIST_BY_REMITTER_MOBILE_FAIL =
  "GET_BENI_LIST_BY_REMITTER_MOBILE_FAIL";

export const PAYRENT_PENNY_DROP_START = "PAYRENT_PENNY_DROP_START";
export const PAYRENT_PENNY_DROP_SUCCESS = "PAYRENT_PENNY_DROP_SUCCESS";
export const PAYRENT_PENNY_DROP_FAIL = "PAYRENT_PENNY_DROP_FAIL";

export const GENERATE_ORDER_AND_PAYMENT_LINK_START =
  "GENERATE_ORDER_AND_PAYMENT_LINK_START";
export const GENERATE_ORDER_AND_PAYMENT_LINK_SUCCESS =
  "GENERATE_ORDER_AND_PAYMENT_LINK_SUCCESS";
export const GENERATE_ORDER_AND_PAYMENT_LINK_FAIL =
  "GENERATE_ORDER_AND_PAYMENT_LINK_FAIL";

//Ypay
export const CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_START =
  "CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_START";
export const CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_SUCCESS =
  "CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_SUCCESS";
export const CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_FAIL =
  "CUSTOMER_DETAILS_BY_CUSTOMER_MOBILE_FAIL";

//Dmt v2
export const GET_REMITTER_DETAILS_FOR_DMTV2_START =
  "GET_REMITTER_DETAILS_FOR_DMTV2_START";
export const GET_REMITTER_DETAILS_FOR_DMTV2_SUCCESS =
  "GET_REMITTER_DETAILS_FOR_DMTV2_SUCCESS";
export const GET_REMITTER_DETAILS_FOR_DMTV2_FAIL =
  "GET_REMITTER_DETAILS_FOR_DMTV2_FAIL";

//ypay Passbook
export const PASSBOOK_DETAILS = "PASSBOOK_DETAILS";

//other by functionalities
export const RESET_DMT_START = "RESET_DMT_START";

export const RESET_DMTV2_START = "RESET_DMTV2_START";

export const CLOSE_REMIITER_POPUP_START = "CLOSE_REMIITER_POPUP_START";

export const AEPS_MERCHANT_KYC_RESET = "AEPS_MERCHANT_KYC_RESET";

export const RESET_RECHARGE_START = "RESET_RECHARGE_START";

export const RESET_LEDGER_REPORTS_START = "RESET_LEDGER_REPORTS_START";

//payout Types

export const DELETE_BENE_FOR_PAYOUT_START = "DELETE_BENE_FOR_PAYOUT_START";
export const DELETE_BENE_FOR_PAYOUT_SUCCESS = "DELETE_BENE_FOR_PAYOUT_SUCCESS";
export const DELETE_BENE_FOR_PAYOUT_FAIL = "DELETE_BENE_FOR_PAYOUT_FAIL";
